import React from "react";
import { Phone, ExternalLink } from "lucide-react";
import Logo from "./Logo";

export const SiteHeader = () => {
  return (
    <header
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-slate-200"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between gap-4">
        <a href="/" className="flex items-center" data-testid="header-logo-link">
          <Logo />
        </a>
        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href="tel:+18339255065"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold bg-white border-2 border-[#63499d]/20 hover:border-[#63499d] text-[#63499d] transition-colors"
            data-testid="header-phone-cta"
          >
            <Phone className="w-4 h-4" />
            833-925-5065
          </a>
          <a
            href="https://www.ricochetfuel.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 sm:px-5 py-2.5 rounded-full text-sm font-bold text-[#2a1f4a] bg-[#ecac1f] hover:bg-[#d99812] transition-colors"
            data-testid="header-main-site-cta"
          >
            Visit Main Site
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
